import React from 'react';

function Jamaica(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124091)">
        <mask
          id="mask0_800_124091"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124091)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#009933"
          />
          <path
            d="M-0.326385 -1.08845L-2.475 -2.66493V0V24V26.6649L-0.326385 25.0884L16.0286 13.0884L17.5121 12L16.0286 10.9116L-0.326385 -1.08845Z"
            fill="#272727"
            stroke="#FECA00"
            strokeWidth="2.7"
          />
          <path
            d="M36.3502 -1.1055L38.475 -2.59477V0V24V26.5948L36.3502 25.1055L19.229 13.1055L17.6517 12L19.229 10.8945L36.3502 -1.1055Z"
            fill="#272727"
            stroke="#FECA00"
            strokeWidth="2.7"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124091">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Jamaica;
